import { LinkRenderer } from '@/components/elements/Link';
import { IComponentSharedTitleAndDescription } from '@/graphql/__generated__/global/types';
import { SOCIAL_MEDIA } from '@/helpers/socialMedia';
import classNames from '@/lib/classNames';
import Link from 'next/link';
import Button from '../../elements/Button';
import { Icon, IconId } from '../../global/Icons';

export const TitleAndDescription = ({
    eyebrow,
    title,
    headingLevel,
    description,
    button,
    leftAligned,
    className,
    showSocialMediaButtons,
}: IComponentSharedTitleAndDescription & {
    className?: string;
}) => {
    const Heading = headingLevel ?? 'h2';

    return (
        <div className={classNames('pb-[4.5rem] text-primary', className)}>
            {!leftAligned ? (
                // Centered Version
                <div className="max-w-md w-full mx-auto">
                    <div className="relative flex flex-col items-center justify-center max-w-md mx-auto text-primary text-center">
                        {eyebrow && <p className="h6 pb-12">{eyebrow}</p>}
                        <Heading className="h2">{title}</Heading>
                        {description && <p className="max-w-xs w-full mx-auto large mt-6">{description}</p>}
                        {button && (
                            <Button asChild variant="outline" size="lg" uppercase className="mt-10">
                                <LinkRenderer {...button}>{button.label}</LinkRenderer>
                            </Button>
                        )}
                    </div>
                </div>
            ) : (
                // Left Version
                <div className={classNames(description && 'grid gap-6')}>
                    {eyebrow && <p className="h6">{eyebrow}</p>}
                    <div className={`${description ? `grid grid-cols-1 md:grid-cols-2 gap-5 items-end text-left` : `flex flex-row justify-between items-center gap-2`}`}>
                        <Heading className="h2">{title}</Heading>
                        {(description || button) && (
                            <div className="flex flex-col items-start gap-6">
                                {description && <p>{description}</p>}
                                {button && !showSocialMediaButtons && (
                                    <Button asChild variant="outline" size="lg">
                                        <LinkRenderer {...button}>{button.label}</LinkRenderer>
                                    </Button>
                                )}
                                {showSocialMediaButtons && (
                                    <div className="grid grid-cols-3 gap-1 md:gap-2 xl:gap-4">
                                        {SOCIAL_MEDIA.map((item) => {
                                            return (
                                                <Button className="hover:fill-white fill-primary" key={item.name} asChild variant="outline" size="lg">
                                                    <Link href={item.url} target="_blank" passHref className="text-[0.55rem] sm:text-xs md:text-[0.55rem] lg:text-sm">
                                                        <Icon id={item.name.toLowerCase() as IconId} className="w-4 h-4 mr-1 lg:mr-2" />
                                                        {item.name}
                                                    </Link>
                                                </Button>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
